export const HOST_NAME = "https://api.thrivingworkplace.in";
// export const HOST_NAME = "http://localhost:4000";
export const BELOW_80 = "#fff06b";
